import React, { Component } from "react";
import "../../src/styles/layout/header.scss";
import { Navbar, Nav, NavDropdown, Badge, Overlay, Modal, Form, Popover } from "react-bootstrap";
import { Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { logout } from "../utils/auth";
import { Redirect } from "react-router-dom";
import Scrollbar from "react-scrollbars-custom";
import { setLoadingPage, setErrorMessage, setTimezoneId, setRealtimeGroupId, setRealtimeGroupName, setReportAssetId, setReportCalendatDate, setReportAssetName } from "../reducers/actions";
import { connect } from "react-redux";
import axios from "axios";
import TimeAgo from "timeago-react";
import { utcToLocal, utcToDate } from "../utils/dateConvert";
import { apiHost } from "../api/apiClient";
import notification from "../Assets/notification.mp3";
import { LinkContainer } from "react-router-bootstrap";
import $ from "jquery";
import signalRHelper from "../utils/signalRHelper";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      role: localStorage.getItem("role"),
      redirect: false,
      popOverDuress: false,
      target: "",
      popOverBehaviour: false,
      targetBehaviour: "",
      popOverNotification: false,
      targetNotification: "",
      alertsDuressList: [],
      alertsBehaviourList: [],
      alertsNotificationList: [],
      duressTotal: 0,
      behaviourTotal: 0,
      notificationTotal: 0,
      pendingDuress: 0,
      pendingBehaviour: 0,
      pendingNotification: 0,
      //states for modal
      modalShow: false,
      modalEvent: "",
      modalAsset: "",
      modalCreated: "",
      modalDifference: "",
      modalAddress: "",
      modalCutomerName: "",
      acknowledgementDescription: "",
      modalUserId: "",
      modalUserName: "",
      ackDesc: "",
      modalAcknowledgeTime: "",
      duressRedirect: false,
      behaviourRedirect: false,
      notificationRedirect: false,
      timeZoneName: "",
      timeZones: [],
      customGroups: false,
      bellIconClick: false,
    };
    this.textInput = React.createRef();
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  async componentDidMount() {
    if (window.location.pathname == "/realTime") {
      this.setState({ customGroups: true });
    }

    if (localStorage.getItem("token") !== null) {
      this.getAlerts();
    }

    // Attach to signalR
    this.handleSignalR();
  }

  releaseSignalR() {
    if (!this.connection) {
      return;
    }
    // Release signalR handlers
    signalRHelper.unsubscribe("Duress");
    signalRHelper.unsubscribe("Behaviour");
    signalRHelper.unsubscribe("Notification");

    this.connection.off("Duress");
    this.connection.off("Behaviour");
    this.connection.off("Notification");
    this.connection = null;
  }

  setCustomGroup = () => {
    this.setState({ customGroups: true });
  };

  removeCustomGroup = () => {
    this.setState({ customGroups: false });
  };

  getAlerts = async () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const assetId = urlParams.get("assetId");
    const assetName = urlParams.get("assetName");
    const assetDate = urlParams.get("assetDate");

    setTimeout(() => {
      if (urlParams.get("assetId")) {
        this.props.setReportAssetIdAction(assetId);
        this.props.setReportAssetNameAction(assetName);
        this.props.setReportCalendatDateAction(assetDate);
      }
    }, 1000);

    try {
      let timezone = await axios.get(`${apiHost}/api/Customer/GetAllTimeZone`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      this.setState({
        timeZones: timezone.data,
        timeZoneName: timezone.data[0].timeZoneCity,
      });
      if (localStorage.getItem("timeZone") == null) {
        localStorage.setItem("timeZone", timezone.data[0].timeZoneCity);
        localStorage.setItem("timeZoneID", timezone.data[0].timeZonesId);
      }
      this.props.setTimezoneIdAction(timezone.data[0].timeZonesId);
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
    document.addEventListener("mousedown", this.handleClickOutside);

    this.handleDuressAndBehaviourCall();
    this.handleNotificationCall();
  };

  handleDuressAndBehaviourCall = async () => {
    try {
      let alertsList = await axios.get(`${apiHost}/api/Event/GetLatestEventsWithCount`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      this.setState({
        alertsDuressList: alertsList.data.Duress,
        alertsBehaviourList: alertsList.data.Behavior,
        TotalBehavior: alertsList.data.TotalBehavior,
        TotalDuress: alertsList.data.TotalDuress,
        pendingDuress: alertsList.data.PendingDuress,
        duressTotal: alertsList.data.TotalDuress,
        pendingBehaviour: alertsList.data.PendingBehavior,
        behaviourTotal: alertsList.data.TotalBehavior,
      });
    } catch (e) {
      this.props.setErrorMessageAction(`${e}`);
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleNotificationCall = async () => {
    try {
      let notification = await axios.get(`${apiHost}/api/Notification/LatestNotificationWithCount`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      this.setState({
        alertsNotificationList: notification.data.Notifications,
        notificationCount: notification.data.NotificationsCount,
      });
      this.notificationPendingAlertCalculation();
    } catch (e) {
      this.props.setErrorMessageAction(`${e}`);
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  changeTimeZone = (timezone, timezoneCityID) => {
    this.props.setTimezoneIdAction(timezone);
    this.setState({ timeZoneName: timezoneCityID });
    localStorage.setItem("timeZoneID", timezone);
    localStorage.setItem("timeZone", timezoneCityID);

    window.location.reload(false);
  };

  async handleSignalR() {
    this.connection = await signalRHelper.getConnection();
    this.addAlerts();
  }

  addAlerts = () => {
    signalRHelper.subscribe("Duress");
    signalRHelper.subscribe("Behaviour");
    signalRHelper.subscribe("Notification");

    this.connection.on("Duress", (data) => {
      this.data = data;
      this.handleDuressAndBehaviourCall();
    });

    this.connection.on("Behaviour", (data) => {
      this.data = data;
      this.handleDuressAndBehaviourCall();
    });

    this.connection.on("Notification", (data) => {
      this.data = data;
      this.handleNotificationCall();
    });
  };
  createNotificationList = (data) => {
    let counter = 0;
    let currentList = [...this.state.alertsNotificationList];
    currentList.forEach((item, index) => {
      if (item.id == data.id) {
        currentList[index] = data;
        counter++;
      }
    });

    if (counter == 0) {
      currentList.push(data);
      this.playAudio();
    }

    currentList.sort(function (x, y) {
      var date1 = new Date(x.gPRMC.created);
      var date2 = new Date(y.gPRMC.created);
      return date2 - date1;
    });

    this.setState({
      alertsNotificationList: currentList,
    });
    this.notificationPendingAlertCalculation();
  };

  notificationPendingAlertCalculation = () => {
    let total = 0;
    if (this.state.alertsNotificationList !== "") {
      this.state.alertsNotificationList.forEach((item, index) => {
        total++;
      });
    }

    let countnot = this.state.notificationCount;
    this.setState({
      notificationTotal: total,
      pendingNotification: countnot,
    });
  };

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    this.releaseSignalR();
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if ($("#popover-contained") != null && event.target.closest('div[id^="popover-contained"]') == null) {
      this.setState({
        popOverDuress: false,
        popOverBehaviour: false,
        popOverNotification: false,
      });
    }
  }

  handleLogOut = () => {
    logout();
  };

  handleOpenBuoy = (event) => {
    this.setState({
      popOverDuress: !this.state.popOverDuress,
      target: event.target,
      bellIconClick: true,
    });
  };

  handleOpenBell = (event) => {
    this.setState({
      popOverNotification: !this.state.popOverNotification,
      targetNotification: event.target,
      bellIconClick: false,
    });
  };

  handleOpenExclamation = (event) => {
    this.setState({
      popOverBehaviour: !this.state.popOverBehaviour,
      targetBehaviour: event.target,
      bellIconClick: true,
    });
  };

  handleClose = () => {
    this.setState({
      modalShow: false,
    });
  };

  handleShow = (event, asset, created, difference, address, customer, id) => {
    this.setState({
      modalUserId: "",
      ackDesc: "",
      modalShow: true,
      modalId: id,
      modalEvent: event,
      modalAsset: asset,
      modalCutomerName: customer,
      modalAddress: address,
      modalCreated: created,
      modalDifference: difference,
    });
  };

  handleDuressViewall = () => {
    this.setState({
      duressRedirect: true,
    });
  };

  handleBehaviourViewall = () => {
    this.setState({
      behaviourRedirect: true,
    });
  };

  handleNotificationViewall = () => {
    this.setState({
      notificationRedirect: true,
    });
  };

  handleAcknowledegmentDescription = (e) => {
    this.setState({
      acknowledgementDescription: e.target.value,
    });
  };

  handleAcknowledged = (event, asset, created, difference, address, customer, id, userId, ackMsg, usrname, ackTime) => {
    this.setState({
      modalShow: true,
      modalId: id,
      modalEvent: event,
      modalAsset: asset,
      modalCutomerName: customer,
      modalAddress: address,
      modalCreated: created,
      modalDifference: difference,
      modalUserId: userId,
      ackDesc: ackMsg,
      modalUserName: usrname,
      modalAcknowledgeTime: ackTime,
    });
  };

  handleAcknowledge = async (id, description) => {
    let url;
    if (this.state.bellIconClick) {
      url = `${apiHost}/api/Event/EventAcknowledgement`;
    } else {
      url = `${apiHost}/api/Notification/NotificationAcknowledgement`;
    }
    this.props.setLoadingPageAction(true);

    try {
      if (this.state.bellIconClick) {
        await axios.post(
          url,
          {
            MessageId: id,
            Acknowledgement: description,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );
      } else {
        await axios.post(
          url,
          {
            MessageId: id,
            Acknowledgement: description,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );
      }
      this.setState({
        modalShow: false,
      });
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  playAudio = () => {
    var x = document.getElementById("myAudio");
    if (x) {
      x.play();
    }
  };

  handleGroupSelection = (id, name) => {
    this.props.setRealtimeGroupIdAction(id);
    this.props.setRealtimeGroupNameAction(name);
    localStorage.setItem("realTimeGroupId", id);
    localStorage.setItem("realTimeGroupName", name);
  };

  render() {
    if (this.state.duressRedirect === true) {
      this.setState({
        duressRedirect: false,
        popOverDuress: false,
        popOverBehaviour: false,
        popOverNotification: false,
      });
      return <Redirect to="/AlertCentre?alert=duress" />;
    }
    if (this.state.behaviourRedirect === true) {
      this.setState({
        behaviourRedirect: false,
        popOverDuress: false,
        popOverBehaviour: false,
        popOverNotification: false,
      });
      return <Redirect to="/AlertCentre?alert=behaviour" />;
    }
    if (this.state.notificationRedirect === true) {
      this.setState({
        notificationRedirect: false,
        popOverNotification: false,
        popOverDuress: false,
        popOverBehaviour: false,
      });
      return <Redirect to="/AlertNotification" />;
    }
    var button;
    if (localStorage.getItem("userName")) {
      button = <Nav.Link href="/manageAccount">{localStorage.getItem("userName")}</Nav.Link>;
    } else {
      button = <Nav.Link href="/login">No Id Available</Nav.Link>;
    }

    let values = JSON.parse(localStorage.getItem("customer"));
    let customerName = "";
    let customerId = "";
    if (values) {
      customerName = values.customerName;
      customerId = values.customerId;
    }

    const versionText = process.env.REACT_APP_VERSION ?? "(V2)";

    return (
      <div className="responsiveLoginNavBar ">
        <div className="loginContainer">
          <Navbar collapseOnSelect expand="lg" variant="dark">
            <LinkContainer to="/home">
              <Navbar.Brand>
                <h3>
                  AssetTrak <span>{versionText}</span>
                </h3>
              </Navbar.Brand>
            </LinkContainer>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="mr-auto">
                <LinkContainer onClick={this.removeCustomGroup} to="/home">
                  <Nav.Link>Dashboard</Nav.Link>
                </LinkContainer>
                <LinkContainer onClick={this.setCustomGroup} to="/realTime">
                  <Nav.Link>Realtime</Nav.Link>
                </LinkContainer>
                {this.state.customGroups && (
                  <div className="realtimeDropdown">
                    <NavDropdown title="Groups" id="collasible-nav-dropdown">
                      <div
                        style={{
                          maxHeight: "60vh",
                          overflowY: "scroll",
                        }}
                      >
                        {this.props.realTimeGroup.length > 0 ? (
                          this.props.realTimeGroup.map((element, index) => {
                            return (
                              <NavDropdown.Item
                                key={index}
                                onClick={() => this.handleGroupSelection(element.groupId, `${element.customername} - ${element.groupName} `)}
                              >
                                {`${element.customername} - ${element.groupName} `}
                              </NavDropdown.Item>
                            );
                          })
                        ) : (
                          <NavDropdown.Item className="navItem" disabled>
                            none assigned
                          </NavDropdown.Item>
                        )}
                      </div>
                    </NavDropdown>
                  </div>
                )}

                <NavDropdown title="Reports" id="collasible-nav-dropdown">
                  {this.props.reportAssetId != "" ? (
                    <NavDropdown.Item
                      href={`/Rpt-MVTL?assetId=${this.props.reportAssetId}&assetName=${this.props.reportAssetName}&assetDate=${this.props.reportDate}`}
                    >
                      MV Trip Log
                    </NavDropdown.Item>
                  ) : (
                    <NavDropdown.Item href="/Rpt-MVTL">MV Trip Log</NavDropdown.Item>
                  )}
                  {this.props.reportAssetId != "" ? (
                    <NavDropdown.Item
                      href={`/Rpt-Visit?assetId=${this.props.reportAssetId}&assetName=${this.props.reportAssetName}&assetDate=${this.props.reportDate}`}
                    >
                      Visit
                    </NavDropdown.Item>
                  ) : (
                    <NavDropdown.Item href="/Rpt-Visit">Visit</NavDropdown.Item>
                  )}

                  <NavDropdown.Item href="/MultiVisit">Multi-Asset Visit</NavDropdown.Item>
                  {this.props.reportAssetId != "" ? (
                    <NavDropdown.Item
                      href={`/Temperature?assetId=${this.props.reportAssetId}&assetName=${this.props.reportAssetName}&assetDate=${this.props.reportDate}`}
                    >
                      Temperature
                    </NavDropdown.Item>
                  ) : (
                    <NavDropdown.Item href="/Temperature">Temperature</NavDropdown.Item>
                  )}
                  <NavDropdown.Divider />

                  <NavDropdown.Item href="/Rpt-summary"> Asset Summary</NavDropdown.Item>

                  <NavDropdown.Item href="/Rpt-Group-Summary"> Group Summary</NavDropdown.Item>

                  {this.props.reportAssetId != "" ? (
                    <NavDropdown.Item
                      href={`/Rpt-LocationData?assetId=${this.props.reportAssetId}&assetName=${this.props.reportAssetName}&assetDate=${this.props.reportDate}`}
                    >
                      Location Data
                    </NavDropdown.Item>
                  ) : (
                    <NavDropdown.Item href="/Rpt-LocationData">Location Data</NavDropdown.Item>
                  )}

                  <NavDropdown.Item href="/Rpt-PointOfInterest">Point Of Interest</NavDropdown.Item>

                  <NavDropdown.Item href="/Rpt-IButton"> IButton Report</NavDropdown.Item>

                  {this.state.role == "SystemAdmin" && <NavDropdown.Item href="/asset-log-report"> Asset Log</NavDropdown.Item>}

                  {this.props.reportAssetId != "" ? (
                    <NavDropdown.Item
                      href={`/Track?assetId=${this.props.reportAssetId}&assetName=${this.props.reportAssetName}&assetDate=${this.props.reportDate}`}
                    >
                      Track
                    </NavDropdown.Item>
                  ) : (
                    <NavDropdown.Item href="/Track">Track</NavDropdown.Item>
                  )}
                </NavDropdown>
                
                <NavDropdown title="Manage" id="collasible-nav-dropdown">
                  {this.state.role == "SystemAdmin" ? (
                    <>
                      <LinkContainer onClick={this.removeCustomGroup} to="/customers">
                        <NavDropdown.Item>Customers SPA</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerId ? `/groups?customerId=${customerId}&customerName=${customerName}` : `/groups`}
                      >
                        <NavDropdown.Item>Groups</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerId ? `/assets?customerId=${customerId}&customerName=${customerName}` : `/assets`}
                      >
                        <NavDropdown.Item>Assets</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerId ? `/devices?customerId=${customerId}&customerName=${customerName}` : `/devices`}
                      >
                        <NavDropdown.Item>Devices</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerId ? `/users?customerId=${customerId}&customerName=${customerName}` : `/users`}
                      >
                        <NavDropdown.Item>Users</NavDropdown.Item>
                      </LinkContainer>
                      <NavDropdown.Divider />
                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerId ? `/notifications?customerId=${customerId}&customerName=${customerName}` : `/notifications`}
                      >
                        <NavDropdown.Item>Notifications</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer onClick={this.removeCustomGroup} to="/events">
                        <NavDropdown.Item>Events</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerId ? `/depots?customerId=${customerId}&customerName=${customerName}` : `/depots`}
                      >
                        <NavDropdown.Item>Depots</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer onClick={this.removeCustomGroup} to="/ibutton">
                        <NavDropdown.Item>iButtons</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerId ? `/zones?customerId=${customerId}&customerName=${customerName}` : `/zones`}
                      >
                        <NavDropdown.Item>POI</NavDropdown.Item>
                      </LinkContainer>
                    </>
                  ) : (
                    <React.Fragment>
                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerId ? `/zones?customerId=${customerId}&customerName=${customerName}` : `/zones`}
                      >
                        <NavDropdown.Item>POI</NavDropdown.Item>
                      </LinkContainer>

                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerId ? `/assets?customerId=${customerId}&customerName=${customerName}` : `/assets`}
                      >
                        <NavDropdown.Item>Assets</NavDropdown.Item>
                      </LinkContainer>

                      <LinkContainer onClick={this.removeCustomGroup} to="/notifications">
                        <NavDropdown.Item>Notifications</NavDropdown.Item>
                      </LinkContainer>
                    </React.Fragment>
                  )}
                </NavDropdown>

                <LinkContainer onClick={this.removeCustomGroup} to="/visioncam">
                  <Nav.Link>Visioncam</Nav.Link>
                </LinkContainer>
                
                <Nav.Link href="https://vttoolsuser-assettrak.visiontrak.com.au/index.php" target="_blank" rel="noopener noreferrer">
                  VtTools
                </Nav.Link>
                
                <LinkContainer onClick={this.removeCustomGroup} to="/tom-delivery">
                  <Nav.Link>TOM Delivery</Nav.Link>
                </LinkContainer>
              </Nav>
              <Nav className="rightMenu">
                <div className="realtimeDropdown">
                  <NavDropdown id="dropdown-item-timezone" className="timezoneDropdown" title={localStorage.getItem("timeZone")}>
                    <div
                      style={{
                        maxHeight: "60vh",
                        overflowY: "scroll",
                      }}
                    >
                      {this.state.timeZones.map((item, index) => {
                        return (
                          <NavDropdown.Item
                            key={index}
                            as="button"
                            onClick={() => this.changeTimeZone(item.timeZonesId, item.timeZoneCity)}
                            value="act"
                          >
                            {item.timeZoneCity}
                          </NavDropdown.Item>
                        );
                      })}
                    </div>
                  </NavDropdown>
                </div>
                <Nav.Link>
                  <div>
                    <div className="notificationContainer" onClick={this.handleOpenBell}>
                      <i className="fa fa-bell-o" size="lg" />
                      {this.state.pendingNotification != 0 && <button className="notificationBadgeFlicker">{this.state.pendingNotification}</button>}
                    </div>
                    <div className="notificationPopup">
                      <Overlay show={this.state.popOverNotification} target={this.state.targetNotification} placement="bottom" containerPadding={20}>
                        <Popover bsPrefix="popover" id="popover-contained">
                          <Popover.Title as="h3">
                            <div className="popoverGroupTitle">
                              <h3>
                                <strong>{this.state.pendingNotification}</strong> Pending Alerts
                              </h3>
                              <p onClick={this.handleNotificationViewall}>View all</p>
                            </div>
                          </Popover.Title>
                          <Popover.Content>
                            <Scrollbar
                              noScrollX
                              style={{
                                width: 326,
                                height: 340,
                              }}
                            >
                              {this.state.alertsNotificationList
                                ? this.state.alertsNotificationList.map((item, index) => {
                                    if (index < 30) {
                                      return (
                                        <ul className="popOverContents">
                                          <li>
                                            <span className="left">
                                              <i className="fa fa-life-buoy"></i>
                                              {item.assetName}{" "}
                                              <i
                                                class="fa fa-info-circle text-primary"
                                                title={`Notification: ${item.eventName} - [${item.uniqueId}]`}
                                              ></i>
                                            </span>
                                            <div className="right">
                                              <div className="leftRight">
                                                {item.userId ? (
                                                  <button
                                                    className="info"
                                                    onClick={() => {
                                                      this.setState({
                                                        bellIconClick: true,
                                                      });
                                                      this.handleAcknowledged(
                                                        item.eventName,
                                                        item.assetName,
                                                        item.created,
                                                        item.difference,
                                                        item.location,
                                                        item.customerName,
                                                        item.id,
                                                        item.userId,
                                                        item.acknowledgedDescription,
                                                        item.userName,
                                                        item.acknowledgeTime
                                                      );
                                                    }}
                                                  >
                                                    <i className="fa fa-info" />
                                                  </button>
                                                ) : (
                                                  <button
                                                    variant="danger"
                                                    onClick={() =>
                                                      this.handleShow(
                                                        item.eventName,
                                                        item.assetName,
                                                        item.created,
                                                        item.difference,
                                                        item.location,
                                                        item.customerName,
                                                        item.id
                                                      )
                                                    }
                                                    size="sm"
                                                  >
                                                    <i className="fa fa-check" />
                                                  </button>
                                                )}
                                              </div>

                                              <div className="rightRight">
                                                <Badge variant="secondary">{<TimeAgo datetime={utcToLocal(item.gPRMC.created)} />}</Badge>
                                              </div>
                                            </div>
                                          </li>
                                        </ul>
                                      );
                                    }

                                    return null;
                                  })
                                : ""}
                            </Scrollbar>
                          </Popover.Content>
                        </Popover>
                      </Overlay>
                    </div>
                  </div>
                </Nav.Link>
                <Nav.Link>
                  <div>
                    <div className="notificationContainer" onClick={this.handleOpenBuoy}>
                      <i className="fa fa-life-buoy" size="lg" />
                      {this.state.pendingDuress != 0 && <button className="notificationBadgeFlicker">{this.state.pendingDuress}</button>}
                    </div>
                    <div className="notificationPopup">
                      <Overlay show={this.state.popOverDuress} target={this.state.target} placement="bottom" containerPadding={20}>
                        <Popover bsPrefix="popover" id="popover-contained" ref={this.textInput}>
                          <Popover.Title as="h3">
                            <div className="popoverGroupTitle">
                              <h3>
                                <strong>{this.state.pendingDuress}</strong> Pending Alerts
                              </h3>
                              <p onClick={this.handleDuressViewall}>View all</p>
                            </div>
                          </Popover.Title>
                          <Popover.Content>
                            <Scrollbar
                              noScrollX
                              style={{
                                width: 326,
                                height: 340,
                              }}
                            >
                              {this.state.alertsDuressList
                                ? this.state.alertsDuressList.map((item, index) => {
                                    if (index < 30) {
                                      return (
                                        <ul className="popOverContents" key={index}>
                                          <li>
                                            <span className="left">
                                              <i
                                                style={
                                                  item.eventId == 59
                                                    ? {
                                                        color: "#a94442",
                                                      }
                                                    : {
                                                        color: "#8a6d3b",
                                                      }
                                                }
                                                className={`fa ${
                                                  item.eventId == 403
                                                    ? "fa-reply-all"
                                                    : item.eventId == 405
                                                    ? "fa-exclamation-circle"
                                                    : item.eventId == 404
                                                    ? "fa-flag-checkered"
                                                    : "fa-life-buoy"
                                                } `}
                                              ></i>
                                              &nbsp;
                                              {item.assetName}{" "}
                                            </span>
                                            <div className="right">
                                              <div className="leftRight">
                                                {item.userId ? (
                                                  <button
                                                    className="info"
                                                    onClick={() => {
                                                      this.setState({
                                                        bellIconClick: false,
                                                      });
                                                      this.handleAcknowledged(
                                                        item.eventName,
                                                        item.assetName,
                                                        item.created,
                                                        item.difference,
                                                        item.location,
                                                        item.customerName,
                                                        item.id,
                                                        item.userId,
                                                        item.acknowledgedDescription,
                                                        item.userName,
                                                        item.acknowledgeTime
                                                      );
                                                    }}
                                                  >
                                                    <i className="fa fa-info" />
                                                  </button>
                                                ) : (
                                                  <button
                                                    variant="danger"
                                                    onClick={() =>
                                                      this.handleShow(
                                                        item.eventName,
                                                        item.assetName,
                                                        item.created,
                                                        item.difference,
                                                        item.location,
                                                        item.customerName,
                                                        item.id
                                                      )
                                                    }
                                                    size="sm"
                                                  >
                                                    <i className="fa fa-check" />
                                                  </button>
                                                )}
                                              </div>

                                              <div className="rightRight">
                                                <Badge variant="secondary">{<TimeAgo datetime={utcToLocal(item.gPRMC.created)} />}</Badge>
                                              </div>
                                            </div>
                                          </li>
                                        </ul>
                                      );
                                    }

                                    return null;
                                  })
                                : ""}
                            </Scrollbar>
                          </Popover.Content>
                        </Popover>
                      </Overlay>
                    </div>
                  </div>
                </Nav.Link>
                <audio id="myAudio">
                  <source src={notification} type="audio/mpeg" />
                </audio>

                <Nav.Link>
                  <div>
                    <div className="notificationContainer" onClick={this.handleOpenExclamation}>
                      <i className="fa fa-exclamation-triangle" size="lg" />
                      {this.state.pendingBehaviour != 0 && <button className="notificationBadge">{this.state.pendingBehaviour}</button>}
                    </div>
                    <div className="notificationPopup">
                      <Overlay show={this.state.popOverBehaviour} target={this.state.targetBehaviour} placement="bottom" containerPadding={20}>
                        <Popover bsPrefix="popover" id="popover-contained">
                          <Popover.Title as="h3">
                            <div className="popoverGroupTitle">
                              <h3>
                                <strong>{this.state.pendingBehaviour}</strong> Pending Alerts
                              </h3>
                              <p onClick={this.handleBehaviourViewall}>View all</p>
                            </div>
                          </Popover.Title>
                          <Popover.Content>
                            <Scrollbar
                              noScrollX
                              style={{
                                width: 326,
                                height: 340,
                              }}
                            >
                              <ul className="popOverContents">
                                {this.state.alertsBehaviourList
                                  ? this.state.alertsBehaviourList.map((item, index) => {
                                      if (index < 30) {
                                        return (
                                          <ul className="popOverContents" key={index}>
                                            <li>
                                              <span className="left">
                                                <i
                                                  style={
                                                    item.eventId == 59
                                                      ? {
                                                          color: "#a94442",
                                                        }
                                                      : {
                                                          color: "#8a6d3b",
                                                        }
                                                  }
                                                  className={`fa ${
                                                    item.eventId == 403
                                                      ? "fa-reply-all"
                                                      : item.eventId == 405
                                                      ? "fa-exclamation-circle"
                                                      : item.eventId == 404
                                                      ? "fa-flag-checkered"
                                                      : "fa-life-buoy"
                                                  } `}
                                                ></i>
                                                &nbsp; {item.assetName}{" "}
                                              </span>
                                              <div className="right">
                                                <div className="leftRight">
                                                  {item.userId ? (
                                                    <button
                                                      className="info"
                                                      onClick={() => {
                                                        this.setState({
                                                          bellIconClick: false,
                                                        });
                                                        this.handleAcknowledged(
                                                          item.eventName,
                                                          item.assetName,
                                                          item.created,
                                                          item.difference,
                                                          item.location,
                                                          item.customerName,
                                                          item.id,
                                                          item.userId,
                                                          item.acknowledgedDescription,
                                                          item.userName,
                                                          item.acknowledgeTime
                                                        );
                                                      }}
                                                    >
                                                      {" "}
                                                      <i className="fa fa-info" />
                                                    </button>
                                                  ) : (
                                                    <button
                                                      variant="danger"
                                                      onClick={() =>
                                                        this.handleShow(
                                                          item.eventName,
                                                          item.assetName,
                                                          item.created,
                                                          item.difference,
                                                          item.location,
                                                          item.customerName,
                                                          item.id
                                                        )
                                                      }
                                                      size="sm"
                                                    >
                                                      <i className="fa fa-check" />
                                                    </button>
                                                  )}
                                                </div>

                                                <div className="rightRight">
                                                  <Badge variant="secondary">{<TimeAgo datetime={utcToLocal(item.gPRMC.created)} />}</Badge>
                                                </div>
                                              </div>
                                            </li>
                                          </ul>
                                        );
                                      }

                                      return null;
                                    })
                                  : ""}
                              </ul>
                            </Scrollbar>
                          </Popover.Content>
                        </Popover>
                      </Overlay>
                    </div>
                  </div>
                </Nav.Link>
                {button}
                <Nav.Link onClick={() => this.handleLogOut()}>Log Off</Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </div>
        <Modal show={this.state.modalShow} size="lg" onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{this.state.modalUserId == "" ? "Acknowledge alert" : <b>{this.state.modalEvent}</b>} </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.modalUserId == "" ? (
              <span>
                <b>{this.state.modalEvent}</b> was triggered by{" "}
              </span>
            ) : (
              "Triggered by "
            )}
            <b>{this.state.modalAsset}</b> on {utcToDate(this.state.modalCreated)} <TimeAgo datetime={this.state.modalDifference} />.
            <br />
            {this.state.modalAddress}
            <br />
            <b>Customer</b> {this.state.modalCutomerName}
            <br />
            {this.state.modalUserId !== "" ? (
              <div>
                Acknowledge Message:<b>{this.state.ackDesc}</b>
              </div>
            ) : (
              <br />
            )}
            {this.state.modalUserId == "" ? (
              <div>
                <b>Remarks</b>
                <Form>
                  <Form.Group controlId="exampleForm.ControlTextarea1">
                    <Form.Control
                      as="textarea"
                      onChange={this.handleAcknowledegmentDescription}
                      placeholder="Optional remarks about your acknowledgement"
                      rows="3"
                    />
                  </Form.Group>
                </Form>
                <p className="modalGraph">
                  By acknowledging this alert you are confirming it has occurred and that it no longer needs to be included in the alert centre
                  notification area. This action and your remarks will be viewable by others.
                  <br />
                  <b>NOTE:</b> Once Alerts are over 24 hours old they are automaticaly removed from the alert centre notification area.
                </p>
              </div>
            ) : (
              <div>
                Acknowledged by {this.state.modalUserName} on {utcToDate(this.state.modalAcknowledgeTime)}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            {this.state.modalUserId == "" ? (
              <div>
                <Button variant="success" size="sm" onClick={() => this.handleAcknowledge(this.state.modalId, this.state.acknowledgementDescription)}>
                  Acknowledge
                </Button>
                &nbsp;
                <Button variant="secondary" size="sm" onClick={this.handleClose}>
                  Cancel
                </Button>
              </div>
            ) : (
              <Button variant="outline-secondary" size="sm" onClick={this.handleClose}>
                Ok
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
  headerHide: state.headerHide,
  timeZoneId: state.timeZoneId,
  realTimeGroup: state.realTimeGroup,
  reportAssetId: state.reportAssetId,
  reportDate: state.reportDate,
  reportAssetName: state.reportAssetName,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
  setTimezoneIdAction: setTimezoneId,
  setRealtimeGroupIdAction: setRealtimeGroupId,
  setRealtimeGroupNameAction: setRealtimeGroupName,
  setReportAssetIdAction: setReportAssetId,
  setReportCalendatDateAction: setReportCalendatDate,
  setReportAssetNameAction: setReportAssetName,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
